import React from 'react';
import { Button, Col, Modal } from 'antd';
import './modalConfirm.css'
import { attachment } from '../utils/default';

const AttachmentModal = ({ visible, onOk, onCancel, notes, attachments }) => {
    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };

      const showAttachment = (item) => {
        if(item.split('.jpg').length || item.split('.png').length || item.split('.jpeg').length || item.split('.gif').length){
          return item;
        }
        else{
          return attachment;
        }
      }
  return (
    <Modal 
    className='AttachmentsModel'
      title={<p className='text-center text-[23px]'>Attachments</p>}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Col className=' mt-2' lg={{ span: 17 }} sm={24} md={24} xs={24}>
        <div className="d-flex flex-wrap mangPeps attachs" style={{ maxWidth: '100%' }}>
          {attachments?.length > 0 && attachments?.map((item, index) => (
            <div key={index} className='mr-1 mb-2'>
              <a href={item} target='_blank' className=''>
                <img src={showAttachment(item)} style={{width:"72px",height:"auto"}} />
              </a>
            </div>
          ))}
        </div>
      </Col>
    </Modal>
  );
};

export default AttachmentModal;